module.exports = __webpack_public_path__ + "static/img/female-3.3724f6ff.png";